export default __webpack_public_path__ + "static/media/volunteering_and_internships.07d7bbf3.pdf";